import React from 'react';
import styled from 'styled-components';
import idx from 'idx';

const getInitials = name => {
  const initials = name.substring(0, 1).toUpperCase();
  return initials;
};
const Avatar = styled.button`
  width: 40px;
  height: 40px;
  background-color: ${({ theme: { colors } }) => colors.primary.primary} !important;
  color: ${({ theme: { colors } }) => colors.light.primary} !important;
  font-weight: 600;
  border-radius: 100px;
`;

export default function UserAvatar({ user, ...rest }) {
  const email = idx(user, _ => _.email) || '';
  return <Avatar {...rest}>{getInitials(email)}</Avatar>;
}
